import { useCallback, useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import { useUserSettingsUi, useUserSettingsUiMutation } from '../../app/query-hooks/use-user-settings-ui';

type DialogContext = 'publish' | 'review';

type SettingKey = 'showPublishPopup' | 'showReviewPopup';

type UseConfirmDialogPreferenceResult = {
    readonly dismissDialog: () => void;
    readonly shouldShowDialog: boolean;
};

const contextToSettingKey: Record<DialogContext, SettingKey> = {
    publish: 'showPublishPopup',
    review: 'showReviewPopup',
};

const getSettingKey = (context: DialogContext): SettingKey => {
    return contextToSettingKey[context];
};

export const useConfirmDialogPreference = (context: DialogContext): UseConfirmDialogPreferenceResult => {
    const { validatingCobrainerApiFetcher } = useContext(ApplicationContext);
    const { data: uiSettings } = useUserSettingsUi(validatingCobrainerApiFetcher, { enabled: true });
    const { userSettingsUiMutationOptimistic } = useUserSettingsUiMutation(validatingCobrainerApiFetcher);

    const settingKey = getSettingKey(context);

    const shouldShowDialog = uiSettings?.[settingKey] !== false;

    const dismissDialog = useCallback((): void => {
        userSettingsUiMutationOptimistic.mutate({ [settingKey]: false });
    }, [settingKey, userSettingsUiMutationOptimistic]);

    return {
        dismissDialog,
        shouldShowDialog,
    };
};
